import { useContext, useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'

import TouRatesPopup from './touRatesPopup'
import TouBars from '../../common/touBars'
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain } from '../../../services/constants'
import { sendViewAnalytics } from '../../common/util/util'

export default function TouSection() {
    const data = useContext(DataContext);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const content = data?.reports?.selectedData?.tou || {}

    function showRates(event: any) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        sendViewAnalytics('/performance', {
                domain: analyticsDomain.trends,
                name: analyticsPage.gridRates
            })
    }

    return (
        <Box width="100%">
            <Stack alignItems="center" direction="row" 
                    justifyContent="center"
                    pt={custom.spacing.xs}
                    pb={custom.spacing.xxs}>
                <Typography variant="szHeading.Regular.xxSmall">
                    Time of use
                </Typography>
                <Button variant='text' sx={{ ml:"auto" }}
                    id="seeRatesLink" onClick={showRates}>
                    <Typography variant="szBody.Medium.Small"
                                color="primary">
                        See your rates
                    </Typography>
                </Button>
            </Stack>
            <Box maxWidth="100%" display="flex" 
                justifyContent={"center"}
                pt={custom.spacing.xxs}
                >
                <TouBars content={content} />
            </Box>
            <Stack direction="row" 
                    justifyContent={"space-between"} 
                    maxWidth="100%"
                    pt={custom.spacing.xxs}
                    pb={custom.spacing.sm}
                    display="flex">
                         
                <Stack direction="row" 
                    alignItems={"center"}
                    justifyContent={"center"}
                    >             
                    <Box height="12px" width="12px" 
                        sx={{ 
                            backgroundColor: 'sz.colors.orange200',
                            mr: custom.spacing.xxxs, 
                            borderRadius: custom.corners2,
                            display: 'inline-block'
                        }}/> 
                    <Typography variant='szBody.Regular.xSmall' 
                        id='offPeakText'
                        mb={custom.spacing.xxxxs}
                        pr={custom.spacing.xxxs} noWrap>   
                        Off-peak
                    </Typography>
                    <Typography variant='szBody.Regular.Small' 
                        mb={custom.spacing.xxxxs}
                        id='offPeakValue' >
                        {content.offPeak}%
                    </Typography>
                </Stack>
                          
                <Stack direction="row" alignItems={"center"}>      
                    <Box height="12px" width="12px" sx={{ 
                            backgroundColor: 'sz.colors.orange300',
                            mx: custom.spacing.xxxs,
                            borderRadius: custom.corners2,
                            display: 'inline-block'
                        }}/> 
                    <Typography variant='szBody.Regular.xSmall' 
                        id='shoulderText' 
                        mb={custom.spacing.xxxxs}
                        pr={custom.spacing.xxxs}>   
                        Shoulder
                    </Typography>
                    <Typography variant='szBody.Regular.Small' 
                        id='shoulderValue' 
                        mb={custom.spacing.xxxxs}>
                        {content.shoulder}%
                    </Typography>
                </Stack>
                        
                <Stack direction="row" alignItems={"center"}>  
                    <Box height="12px" width="12px" sx={{ 
                            backgroundColor: 'sz.colors.orange400',
                            mx: custom.spacing.xxxs,
                            borderRadius: custom.corners2,
                            display: 'inline-block'
                        }}/> 
                    <Typography variant='szBody.Regular.xSmall' 
                        id='peakText' 
                        mb={custom.spacing.xxxxs}
                        pr={custom.spacing.xxxs}>   
                        Peak
                    </Typography>
                    <Typography variant='szBody.Regular.Small' 
                        id='peakValue' 
                        mb={custom.spacing.xxxxs}>
                        {content.peak}%
                    </Typography>
                </Stack>
                
            </Stack>
            <TouRatesPopup anchorEl={anchorEl} close={()=>setAnchorEl(null)} />
        </Box>
    )
}